import React, { useState } from 'react'
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table } from 'reactstrap';
import ClonarJornada from './ClonarJornada';

const Jornadas = (props) => {


    const diasSemana = ["L", "M", "X", "J", "V", "S", "D"]

    const [showModal, setShowModal] = useState(false);


    const addJornada = (diaSem) => {
        props.addJornada(diaSem)
    }


    const renderInputs = (diaSem) => {
        const jornadasDia = props.jornadas.filter(jornada => jornada.diaSem === diaSem);
        return jornadasDia.map((jornada, index) => (
            <div key={index} >

                <FormGroup>
                    <Row className='mt-1 text-right'>

                        <Col>
                            <span ><Button style={{ boxShadow: "none" }} className='' color="" size="sm" type="button" onClick={(e) => props.removeJornada(props.jornadas.indexOf(jornada))}>X</Button></span>
                        </Col>
                    </Row>
                    <Row>
                        <Label sm={1}><i className='ni ni-bold-right text-success'></i></Label>
                        <Col sm={10}>
                            <Input type='time' className='' value={jornada.horaEntrada} onChange={(e) => props.handleJornadaChange(props.jornadas.indexOf(jornada), "horaEntrada", e.target.value)} required />

                        </Col>

                    </Row>
                    <Row>
                        <Label sm={1}><i className='ni ni-bold-left text-warning' ></i></Label>
                        <Col sm={10}>
                            <Input type='time' className='' value={jornada.horaSalida} onChange={(e) => props.handleJornadaChange(props.jornadas.indexOf(jornada), "horaSalida", e.target.value)} required />
                        </Col>
                    </Row>


                </FormGroup>
            </div>
        ));
    };

    return (
        <>
            <Row className='text-right mb-3'>
                <Col> <Button color='primary' size='sm' onClick={() => setShowModal(true)}> Copiar días</Button></Col>
            </Row>

            <Table  >
                <thead>
                    <tr>
                        <th>Lunes</th>
                        <th>Martes</th>
                        <th>Miércoles</th>
                        <th>Jueves</th>
                        <th>Viernes</th>
                        <th>Sábado</th>
                        <th>Domingo</th>
                    </tr>
                </thead>
                <tbody>

                    <tr>

                        {diasSemana.map((dia, index) => (
                            <td key={index}>
                                {renderInputs(dia)}
                                <Row><Button block outline color="primary" size="sm" type="button" onClick={() => addJornada(dia)}>Añadir horario</Button></Row>
                            </td>
                        ))}
                    </tr>
                </tbody>
            </Table>



            <Modal
                className="modal-dialog-centered"
                isOpen={showModal}
                toggle={() => console.log()}
            >
                <ModalHeader>
                    <h5 className='modal-title'>Copiar jornada</h5>


                </ModalHeader>
                <ModalBody>
                    <ClonarJornada jornadas={props.jornadas} copiarJornada={props.copiarJornada}></ClonarJornada>
                </ModalBody>

                <ModalFooter>
                    <Button
                        data-dismiss="modal"
                        type="button"
                        onClick={() => setShowModal(false)}
                    > Cerrar</Button>
                </ModalFooter>
            </Modal>

        </>
    );
};

export default Jornadas